import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { publicDataService } from '../services/publicDataService';
import SEO from '../components/SEO';
import PageTransition from '../components/PageTransition';

const Gallery = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    const loadGallery = async () => {
      try {
        const res = await publicDataService.getGalleryImages();
        if (res.status === 'success' || Array.isArray(res.data)) {
          setImages(res.data || []);
        }
      } catch (err) {
        console.error("Gallery failed to load", err);
      } finally {
        setLoading(false);
      }
    };
    loadGallery();
  }, []);

  const categories = ['all', 'exterior', 'interior', 'scenic', 'amenities'];
  const filteredImages = filter === 'all' ? images : images.filter(img => img.category === filter);

  return (
    <PageTransition>
      <SEO title="Gallery | R. Venue Apartelle" />
      <div className="pt-32 pb-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h1 className="font-serif text-4xl md:text-6xl text-brand-olive mb-4">Our Gallery</h1>
            <div className="w-24 h-1 bg-brand-gold mx-auto mb-8"></div>
            
            <div className="flex flex-wrap justify-center gap-4">
              {categories.map(cat => (
                <button
                  key={cat}
                  onClick={() => setFilter(cat)}
                  className={`px-6 py-2 rounded-full text-sm font-bold uppercase tracking-widest transition-all ${
                    filter === cat ? 'bg-brand-olive text-white shadow-lg' : 'bg-white text-brand-olive hover:bg-brand-cream'
                  }`}
                >
                  {cat}
                </button>
              ))}
            </div>
          </div>

          {loading ? (
            <div className="flex justify-center py-20">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-olive"></div>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredImages.map((img, idx) => (
                <motion.div
                  key={img.id || idx}
                  layout
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  className="aspect-square overflow-hidden rounded-lg shadow-xl group relative"
                >
                  <img
                    src={img.url}
                    alt={img.alt_text || 'R. Venue Apartelle'}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-brand-olive/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                    <span className="text-white font-bold uppercase tracking-widest text-sm border border-white px-6 py-2">View Detail</span>
                  </div>
                </motion.div>
              ))}
            </div>
          )}
        </div>
      </div>
    </PageTransition>
  );
};

export default Gallery;